<template>
    <div class="company-list">
     <v-card 
      class="mx-auto"
      max-width="785"
      style="margin-bottom:50px;">
     Googleログインをして気になる会社を登録してみよう。
     </v-card>
   </div>
</template>

<script>

export default {
    
}
</script>